// Custom theme colours
const themeColors = {
  black1: '#1c1b1a',
  white1: '#f5f7f9',
};

// Custom background colours
const backgroundColors = {
  backgroundLight: '#ffffff',
  backgroundDark: '#1c1b1a',
  backgroundSecondary: '#F2F2F2',
  backgroundTertiary: '#E8F5FF', // '#EFEFEF',
};

// Theme variant colours
const themeVariantColors = {
  themeLightMain: '#1c1b1a',
  themeLightInverse: '#efefef',
  themeLightBackground: backgroundColors.backgroundLight,

  themeDarkMain: '#ffffff',
  themeDarkInverse: '#1c1b1a',
  themeDarkBackground: backgroundColors.backgroundDark,

  themeSecondaryMain: '#1c1b1a',
  themeSecondaryInverse: '#ffffff',
  themeSecondaryBackground: backgroundColors.backgroundSecondary,

  themeTertiaryMain: '#0085E5',
  themeTertiaryInverse: '#ffffff',
  themeTertiaryBackground: backgroundColors.backgroundTertiary,
};

// Core colours override
const coreColors = {
  headingsText: '#121212',
  bodyText: '#121212',
  overlayText: '#ffffff',
  linkText: '#0085E5',
  linkHover: '#121212',
  buttonBorder: '#ffffff',
  buttonBackground: '#1c1b1a',
  buttonText: '#ffffff',
  buttonBorderHover: '#0085E5',
  buttonBackgroundHover: '#0085E5',
  buttonTextHover: '#ffffff',
  buttonAltBorder: '#1c1b1a',
  buttonAltBackground: '#ffffff',
  buttonAltText: '#1c1b1a',
  buttonAltBorderHover: '#0085E5',
  buttonAltBackgroundHover: '#0085E5',
  buttonAltTextHover: '#ffffff',
  interactiveBorder: '#121212',
  interactiveBackground: '#f5f7f9',
  interactiveText: '#1c1b1a',
  interactiveBorderHover: '#1c1b1a',
  interactiveBackgroundHover: '#1c1b1a',
  interactiveTextHover: '#ffffff',
  navigationLinkText: '#ffffff',
  navigationLinkHover: '#0085E5',
  headerBackground: '#1c1b1a',
  bodyBackground: '#ffffff',
  footerBackground: '#1c1b1a',
  footerSubBackground: '#121212',
  footerLinkText: '#ffffff',
  footerLinkHover: '#0085E5',

  formInputBorder: '#121212',
  formInputBorderError: '#F43319',
  formInputBackground: '#ffffff',
  formInputText: '#121212',
  formErrorText: '#F43319',
  itemBorder: '#121212',
  dropShadow: 'transparent',
  loadingIndicator: '#ffffff',
  socialIcon: '#ffffff',

  headingsTextDark: '#ffffff',
  bodyTextDark: '#ffffff',
  overlayTextDark: '#ffffff',
  linkTextDark: '#ffffff',
  linkHoverDark: '#e1e1e1',
  buttonBorderDark: '#000000',
  buttonBackgroundDark: '#ffffff',
  buttonTextDark: '#000000',
  buttonBorderHoverDark: '#000000',
  buttonBackgroundHoverDark: '#f5f3f5',
  buttonTextHoverDark: '#000000',
  buttonAltBorderDark: '#ffffff',
  buttonAltBackgroundDark: '#dcdcdc',
  buttonAltTextDark: '#000000',
  buttonAltBorderHoverDark: '#ffffff',
  buttonAltBackgroundHoverDark: '#f5f3f5',
  buttonAltTextHoverDark: '#000000',
  interactiveBorderDark: '#000000',
  interactiveBackgroundDark: '#000000',
  interactiveTextDark: '#ffffff',
  interactiveBorderHoverDark: '#1c1b1a',
  interactiveBackgroundHoverDark: '#1c1b1a',
  interactiveTextHoverDark: '#efefef',
  navigationLinkTextDark: '#ffffff',
  navigationLinkHoverDark: '#f5f3f5',
  footerLinkTextDark: '#ffffff',
  footerLinkHoverDark: '#f5f3f5',
  headerBackgroundDark: '#000000',
  bodyBackgroundDark: '#121212',
  footerBackgroundDark: '#000000',
  footerSubBackgroundDark: '#000000',

  formInputBorderDark: '#000000',
  formInputBorderErrorDark: '#F43319',
  formInputBackgroundDark: '#ffffff',
  formInputTextDark: '#000000',
  formErrorTextDark: '#F43319',
  itemBorderDark: '#000000',
  dropShadowDark: 'transparent',
  loadingIndicatorDark: '#ffffff',
  socialIconDark: '#ffffff',
};

// Theme classes for custom styling, these must be included in the safe list for Tailwind to process
const themeVariants = [];

const fontFamily = {
  primary: ['Nunito Sans', 'sans-serif'],
  secondary: ['Nunito Sans', 'sans-serif'],
};

// Override font sizes as required
const themeFontSizes = {
  // H1
  '7xl': [
    '72px',
    {
      lineHeight: '1',
      letterSpacing: '1px',
      fontWeight: '600',
    },
  ],
  '6xl': [
    '64px',
    {
      lineHeight: '1',
      letterSpacing: '1px',
      fontWeight: '600',
    },
  ],
  '5xl': [
    '64px',
    {
      lineHeight: '1',
      letterSpacing: '1px',
      fontWeight: '600',
    },
  ],
  // H2
  '4xl': [
    '48px',
    {
      lineHeight: '1',
      letterSpacing: '1px',
      fontWeight: '600',
    },
  ],
  // H3
  '3xl': [
    '36px',
    {
      lineHeight: '40px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  // H4
  '2xl': [
    '32px',
    {
      lineHeight: '38px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  // H5
  xl: [
    '30px',
    {
      lineHeight: '38px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  // H6
  lg: [
    '28px',
    {
      lineHeight: '36px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  md: [
    '24px',
    {
      lineHeight: '32px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
  base: [
    '18px',
    {
      lineHeight: '26px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
  sm: [
    '16px',
    {
      lineHeight: '24px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
};

const spacing = {
  'vertical-nav': '200px',
  'header-height': '140px',
  'header-height-scrolled': '100px',
  'mobile-header-height': '60px',
};

module.exports = {
  themeColors,
  backgroundColors,
  themeVariantColors,
  coreColors,
  themeVariants,
  fontFamily,
  themeFontSizes,
  spacing,
};
